import type * as React from "react";

import {
  type ColDef,
  type ICellRendererParams,
} from "@/shared/foundation/primitives/Table";

import styles from "./RowActionsMenu.module.css";

/** Column id of the trailing row-actions column. */
export const ROW_ACTIONS_COLUMN_ID = "row_actions";

/**
 * The trailing "…" column of a list table. `lockVisible` keeps it out of the
 * column picker's control and always on, the same exemption `DataTable` gives
 * its own selection and expand columns; consumers leave it out of their
 * picker options. `render` returns the row's `<RowActionsMenu>`.
 */
export function rowActionsColumn<TData>(
  render: (row: TData) => React.ReactNode,
): ColDef<TData> {
  return {
    colId: ROW_ACTIONS_COLUMN_ID,
    headerName: "",
    width: 56,
    minWidth: 56,
    maxWidth: 56,
    flex: 0,
    sortable: false,
    resizable: false,
    suppressMovable: true,
    lockVisible: true,
    hide: false,
    cellClass: styles.cell,
    cellRenderer: (p: ICellRendererParams<TData>) =>
      p.data ? render(p.data) : null,
  };
}
